import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findClearingList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/clearingList?` + params,
        method: 'GET'
    })
}
export const payPlace = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/payPlace?` + params,
        method: 'GET',
    })
}

export const returnPlace = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/returnPlace?`+params,
        method: 'GET'
    })
}






export const findClassifySelect = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/project_plan/select`,
        method: 'GET'
    })
}
export const addSystemClassify = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/project_plan`,
        method: 'POST',
        data: params
    })
}
export const editSystemClassify = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/project_plan`,
        method: 'PUT',
        data: params
    })
}
export const delSystemClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/project_plan/${id}`,
        method: 'DELETE',
    })
}